//import { useMutation } from "react-admin";

import { useContext, useState } from "react";

import { PaymentCreateContext } from "../pages/payment/payment-addproduct/PaymentCreateContext";
import PaymentResult from "../models/PaymentResult";
import Receipt from "../models/Receipt";
import SFError from "../models/SfError";
import moment from "moment";
import settings from "../utils/settings";

const useMakeaPaymentFetch = (lan = "th-TH") => {
  const [state] = useContext(PaymentCreateContext);
  const [receipt, setReceipt] = useState();
  const pay = async (note = "", customTime) => {
    const { token, realmId, branchId, id } = settings();

    try {
      const bodyData = createPaymentTransaction(state, lan);
      let result;
      if (bodyData.image) {
        let formData = new FormData();
        for (const name in bodyData) {
          if (name === "image") {
            formData.append(name, bodyData[name].rawFile);
          } else {
            if (typeof bodyData[name] === "object") {
              formData.append(name, JSON.stringify(bodyData[name]));
            } else {
              const cleanedData = _cleanDatabeforeFormAppend(
                name,
                bodyData[name]
              );
              formData.append(name, cleanedData);
            }
          }
        }

        if (customTime) {
          formData.append(
            "create_local_time",
            moment(customTime).format("YYYY-MM-DD HH:mm:ss")
          );
        } else {
          formData.append(
            "create_local_time",
            moment().format("YYYY-MM-DD HH:mm:ss")
          );
        }
        formData.append("create_by_id", id);
        formData.append("realm_id", realmId);
        if (branchId) formData.append("branch_id", branchId);
        formData.append("action", "upload_image");
        let options = {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        delete options.headers["Content-Type"];

        result = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/payment/transaction`,
          options
        );
      } else {
        let body = customTime
          ? {
              ...createPaymentTransaction(state, lan),
              realm_id: realmId,
              remark: note,
              create_by_id: id,
              create_local_time: moment(customTime).format(
                "YYYY-MM-DD HH:mm:ss"
              ),
            }
          : {
              ...createPaymentTransaction(state, lan),
              realm_id: realmId,
              remark: note,
              create_by_id: id,
              create_local_time: moment().format("YYYY-MM-DD HH:mm:ss"),
            };
        if (branchId) body.branch_id = branchId;
        result = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/payment/transaction`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify(body),
          }
        );
      }

      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return error.json();
      }
      const r = await result.json();

      const paymentResult = new PaymentResult(r.payload);

      const receiptResult = new Receipt({
        paymentResult: {
          ...paymentResult.getPayloadData(),
          date: customTime
            ? moment(customTime).format("YYYY-MM-DD HH:mm:ss")
            : paymentResult.getPayloadData().date,
        },
        items: state.items,
        offer: state.offer,
        discount: state.discount,
        tierPrivileges: state.tierPrivileges,
      });

      return setReceipt(receiptResult);
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return sfError.json();
    }
  };
  return { pay, receipt };
};

const createPaymentTransaction = (data, lan) => {
  if (!data) return {};

  console.log(data);

  const pricebeforeDiscount = _getTotalPrice(data.items);
  data = { pricebeforeDiscount, ...data };
  const items = createItems(data, lan);
  const payments = createPayments(data);
  const summary = createSummary(data);

  const result = {
    currency_code: "THB",
    items: items,
    payment: payments,
    summary: summary,
  };

  if (data.deliveryCost && data.deliveryCost > 0) {
    result.delivery_cost = data.deliveryCost;
    // result.remark = JSON.stringify({ delivery_cost: data.deliveryCost ?? 0 });
  }
  //Move image(slip) from payment to outside world
  result.payment.payment_channels.forEach((channel) => {
    if (channel.image) {
      result.image = channel.image;
    }
    //Assume only one channel so remove delivery cost from here
    if (channel.delivery_cost) {
      result.delivery_cost = channel.delivery_cost;
    }
  });

  if (data.member?.id) {
    return {
      ...result,
      member_id: data.member.id,
      tier_name: data.currentTier?.name ?? "",
    };
  }

  if (data.guest) {
    return {
      ...result,
      guest: data.guest?.getPayloadforPayment(),
    };
  }

  //Default as Guest
  return {
    ...result,
    guest: {},
  };
};

const createItems = (
  {
    items,
    offer,
    pointasCash,
    tierPrivileges,
    discount,
    pricebeforeDiscount,
    currentTier,
  },
  lan
) => {
  let result = [];
  items.forEach((item) => {
    delete item.image_url;
    result.push({ ...item.getPayloadData() });
  });

  //Tier discount เอาcoupon มาแตกแล้วยัดใส่
  if (tierPrivileges) {
    tierPrivileges.forEach((privilege) => {
      result.push(
        privilege.getPayloadforPayment(pricebeforeDiscount, currentTier.id)
      );
    });
  }

  if (discount) {
    result.push(discount.getPayloadData(pricebeforeDiscount, lan));
  }

  if (offer) {
    result.push(offer.getPayloadData(0, lan));
  }

  if (pointasCash && pointasCash.point > 0) {
    result.push(pointasCash.getPayloadData());
  }
  return result;
};

const createPayments = ({
  items,
  offer,
  pointasCash,
  tierPrivileges,
  discount,
  pricebeforeDiscount,
  paymentChannels,
}) => {
  const totalDiscount = _getTotalDiscount({
    items,
    pointasCash,
    tierPrivileges,
    discount,
    pricebeforeDiscount,
  });

  const total = pricebeforeDiscount - Math.abs(totalDiscount);

  return {
    option: "Full",
    paid_amount: total,
    payment_channels: paymentChannels.map((paymentChannel) =>
      paymentChannel.getPayloadforPayment()
    ),
  };
};

const createSummary = (data) => {
  const redeemAmount = data.pointasCash?.point ?? 0;
  const totalDiscount = _getTotalDiscount(data);

  if (data.guest) {
  }

  const { earnPoint, earnCash, rewardItemId, rewardInstanceId } = settings();
  const totalPayment = data.pricebeforeDiscount ?? 0;

  const totalRevenue = totalPayment - totalDiscount;

  const qty = data.items.reduce((total, item) => {
    return total + item.qty;
  }, 0);

  const earnAmount = getTotalPointwithPointOffer(
    getBaseEarn(totalRevenue, earnPoint, earnCash, data.tierPrivileges),
    data.offer
  );

  let totalEarn = earnAmount;
  if (
    data.tierPrivileges &&
    data.tierPrivileges.length > 0 &&
    data.tierPrivileges[0].coupon
  ) {
    totalEarn = data.tierPrivileges[0].coupon.getEarnPointNumber(earnAmount);
  }

  return {
    total_payment: totalPayment,
    total_revenue: totalRevenue,
    total_discount: 0 - Math.abs(totalDiscount),
    total_qty: qty,
    earn_amount: totalEarn,
    redeem_amount: -Number(redeemAmount),
    outstanding_amount: 0,
    reward_item_id: rewardItemId,
    reward_instance_id: rewardInstanceId,
  };
};

const getBaseEarn = (payment) => {
  const { earnPoint, earnCash } = settings();

  return Math.floor((payment * earnPoint) / earnCash);
};

const getTotalPointwithPointOffer = (point, offer) => {
  if (!offer || !offer.coupons) return point;

  return offer.coupons.reduce((totalPoint, coupon) => {
    if (coupon.type === "Reward") {
      return totalPoint + coupon.value;
    } else if (coupon.type === "Multiplier") {
      return totalPoint * coupon.value;
    } else return totalPoint;
  }, point);
};

const _getTotalPrice = (items) => {
  if (!items) return 0;
  return items.reduce((total, item) => {
    return total + item.chargeAmount * item.qty;
  }, 0);
};

const _getTotalDiscount = ({
  pricebeforeDiscount,
  pointasCash,
  tierPrivileges,
  discount,
}) => {
  const pointasCashdiscount =
    pointasCash && pointasCash?.discount ? Math.abs(pointasCash?.discount) : 0;
  const tierDiscount =
    tierPrivileges?.reduce(
      (total, tierPrivilege) => {
        return (
          total +
          Math.abs(tierPrivilege.coupon.getDiscountNumber(pricebeforeDiscount))
        );
      },

      0
    ) ?? 0;
  const discountDiscount = discount
    ? Math.abs(discount?.getTotalDiscount(pricebeforeDiscount))
    : 0;

  return pointasCashdiscount + tierDiscount + discountDiscount;
};

const _cleanDatabeforeFormAppend = (name, data) => {
  if (name === "authorize_pin") {
    return String(data); //DOesn't work
  } else return data;
};
export {
  createPaymentTransaction,
  // useMakeaPayment,
  getBaseEarn,
  getTotalPointwithPointOffer,
  useMakeaPaymentFetch,
  //createSummary,//This must use only
};
